import React, { useRef } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Button } from "react-md";

import { MSpinner } from "components/Shared";
import TextBlock from "components/Shared/TextBlock";
import {
  setMultiFactorMethodsForUser,
} from "requests/profile";
import MDialog from "components/Shared/MDialog.tsx";

const RemoveTwoFactorSetup = (props) => {
  const mounted = useRef(true);

  const {
    profile,
    internetUserId,
    multiFactorMethod,
    closeRemoveDialog,
    multiFactorSetupResponse,
    setMultiFactorSetupResponse,
  } = props;
  const UserId = internetUserId ? internetUserId : profile.internetUserId;

  let submitMultiFactorSetup = () => {
    setMultiFactorSetupResponse({ data: null, isFetching: true });
    setMultiFactorMethodsForUser(UserId, {
      multiFactorMethod: multiFactorMethod,
      removeMethod: true,
      settingsJson: "",
    }, (s) => setMultiFactorSetupResponse({ data: s, isFetching: false }), mounted);
  };

  let getFriendlyName = (name) => {
    switch (name) {
      case "Email a verification code":
        return "Email A Verification Code";
      case "Text a verification code to my phone":
        return "Text A Verification Code";
      case "Code is always 123456":
        return "Code Is Always 123456";
      default:
        break;
    }
  };

  return (
    <>
      <MDialog
        id={"dialog-remove-auth-method"}
        visible={multiFactorSetupResponse.data === null}
        title={"Remove Verification Method"}
        width={500} height={400}>
        <>
          {multiFactorSetupResponse.isFetching &&
            <div className="two-factor-setup-spinner">
              <TextBlock field={`Processing...`} />
              <MSpinner />
            </div>}
          {!multiFactorSetupResponse.isFetching &&
            <>
              <TextBlock field={`Are you sure you would like to remove "${getFriendlyName(multiFactorMethod)}"?`} />
              <hr />
              <div className="verify-controls">
                <Button raised primary onClick={() => closeRemoveDialog()}>No</Button>
                <Button raised primary onClick={() => submitMultiFactorSetup()}>Yes</Button>
              </div>
            </>
          }
        </>
      </MDialog>
      <MDialog
        id={"dialog-auth-method-removed"}
        visible={multiFactorSetupResponse.data !== null}
        title={"Remove Verification Method"}
        width={500} height={400}>
        <>
          {multiFactorSetupResponse.data && multiFactorSetupResponse.data.editInitiated
            ? <TextBlock field={`"${getFriendlyName(multiFactorMethod)}" Successfully Removed`} />
            : <TextBlock field={`There Was An Issue Removing "${getFriendlyName(multiFactorMethod)}". Please Try Again, Or If The Issue Persists Please Contact Support.`} />}
        </>
        <hr />
        <div className="verify-controls">
          <Button raised primary onClick={() => closeRemoveDialog()}>Continue</Button>
        </div>
      </MDialog>
    </>
  );
};

RemoveTwoFactorSetup.propTypes = {
  profile: PropTypes.object,
  internetUserId: PropTypes.number,
  multiFactorMethod: PropTypes.string,
  closeRemoveDialog: PropTypes.func,
  multiFactorSetupResponse: PropTypes.object,
  setMultiFactorSetupResponse: PropTypes.func,
};

const mstp = state => ({
  profile: state.user.profile,
});

export default connect(mstp)(RemoveTwoFactorSetup);